import { render, staticRenderFns } from "./salesAnalysis.vue?vue&type=template&id=5181ff97&scoped=true&"
import script from "./salesAnalysis.vue?vue&type=script&lang=js&"
export * from "./salesAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./salesAnalysis.vue?vue&type=style&index=0&id=5181ff97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181ff97",
  null
  
)

export default component.exports